interface Terms {
  desired_advance: string;
  tenure: string;
}

export class TermsStorage {
  private static STORAGE_KEY = "chosen_terms";

  public static remove(): void {
    try {
      sessionStorage.removeItem(TermsStorage.STORAGE_KEY);
    } catch {
      // ignore (storage may be unavailable)
    }
  }

  public static set(desired_advance: string, tenure: string): void {
    try {
      sessionStorage.setItem(
        TermsStorage.STORAGE_KEY,
        btoa(JSON.stringify({ desired_advance, tenure }))
      );
    } catch {
      // ignore (storage may be unavailable)
    }
  }

  public static getStoredOrDefaultTerms(
    loan_values: string[],
    loan_tenures: string[],
  ): Terms | undefined {
    const stored_terms = TermsStorage.parseStoredTerms();
    if (stored_terms && TermsStorage.validStoredTerms(stored_terms, loan_values, loan_tenures)) {
      return stored_terms;
    } else {
      return undefined;
    }
  }

  private static validStoredTerms(
    terms: Terms, loan_values: string[], loan_tenures: string[]
  ) {
    return loan_values.includes(terms.desired_advance) && loan_tenures.includes(terms.tenure);
  }

  private static parseStoredTerms(): Terms | null {
    try {
      const stored_terms = sessionStorage.getItem(TermsStorage.STORAGE_KEY);
      if (stored_terms) {
        const terms = JSON.parse(atob(stored_terms)) as { desired_advance: number, tenure: number };
        return {
          desired_advance: terms.desired_advance.toString(),
          tenure: terms.tenure.toString()
        };
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}
